import { render, staticRenderFns } from "./ObjectLayup.vue?vue&type=template&id=26baa074&"
import script from "./ObjectLayup.vue?vue&type=script&lang=js&"
export * from "./ObjectLayup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports